<template>
  <div>
    <!-- Exemple

    <input type="text" class="form-control" id="heure_debut" placeholder="Horaire de début de l'événement" v-model="start_time" data-vv-as="Horaire de début" v-validate="'required'" name="heure_debut">
            {{ errors.first('heure_debut') }}
            <div v-show="errors.has('heure_debut')" class="alert alert-danger mt-3">{{ errors.first('heure_debut') }}</div>
            -->
    <h1 class="display-4">{{ h1 }}</h1>
    <hr />
    <b-container>
      <form @submit.prevent="edit">
        <b-alert variant="warning" :show="disableDate">Attention il y a déjà des inscrits pour cet événement, modification impossible, merci de contacter l'équipe Salesforce Ionis.</b-alert>
        <!-- <div class="form-group">
          <label for="title" class="required">Titre</label>
          <input type="text" class="form-control" id="title" name="title" placeholder="Titre de l'événement" v-model="title" data-vv-as="Titre" v-validate="'required'">
          <div v-show="errors.has('title')" class="alert alert-danger mt-3">{{ errors.first('title') }}</div>
        </div> -->
        <div class="form-group" v-show="!this.id && schools_filter.length > 1">
          <label for="Schools" class="required">Ecole</label>
          <select class="form-control" id="Schools" name="Schools" @change="getEstablishments(); getTypes(schoolId); addSchoolSF(schoolId); addDivisionSF(schoolId); hasImages(schoolId)" v-model="schoolId" data-vv-as="Ecole" v-validate="'required'">
            <option value="">--- Sélectionnez une école ---</option>
            <option v-for="item in schools_filter" :value="item.id" :key="item.id">{{ item.name }}</option>
          </select>
          <div v-show="errors.has('Schools')" class="alert alert-danger mt-3">{{ errors.first('Schools') }}</div>
          <!-- <div class="alert alert-danger mt-3" v-show="error_form.school">
            Vous devez choisir une école
          </div> -->
        </div>
        <div class="form-group" v-if="establishments_filter.length > 1 && !this.id">
          <label class="required">Choix des établissements</label>
          <div class="row ml-0">
            <div class="col-sm-2 custom-control custom-checkbox" v-for="item in establishments_filter" :key="item.id">
              <input class="custom-control-input" type="checkbox" name="Establishments" :value="item.id" :id="'defaultCheck1' + item.id" data-vv-as="Etablissements" v-model="establishments_selected" v-validate="'required'">
              <label class="custom-control-label" :for="'defaultCheck1' + item.id">
                {{ item.school.name }} {{ item.city.name }}
              </label>
            </div>
          </div>
          <div v-show="errors.has('Establishments')" class="alert alert-danger mt-3">{{ errors.first('Establishments') }}</div>
          <div v-show="isISG && this.typeId === '5b9fcacdc2e4315bd836890d'" class="alert alert-warning mt-3">Pour la création d'événement JPO, merci de cocher seulement la case établissement : {{ this.establishments_filter[0].school.name }} France</div>
          <!-- <div class="alert alert-danger mt-3" v-show="error_form.establishment">
            Vous devez choisir au moins un établissement
          </div> -->
        </div>
        <div class="form-group" v-if="establishments_filter.length > 0 && this.id && schools_filter.length > 2">
          <label for="Establishments" class="required">Etablissement</label>
          <select class="form-control" id="Establishments" name="EstablishmentsSelect" v-model="establishmentId" data-vv-as="Etablissement" v-validate="'required'">
            <option value="">--- Sélectionnez un établissement ---</option>
            <option v-for="item in establishments_filter" :value="item.id" :key="item.id">{{ item.school.name }} {{ item.city.name }}</option>
          </select>
          <div v-show="errors.has('EstablishmentsSelect')" class="alert alert-danger mt-3">{{ errors.first('EstablishmentsSelect') }}</div>
        </div>
        <div class="form-group" v-show="schoolId != ''">
          <label for="Types" class="required">Type d'événement</label>
          <select class="form-control" id="Types" name="Types" v-model="typeId" @change="addTypeSF(typeId); getLabels(true); getLinks(true)" data-vv-as="Type" v-validate="'required'" :disabled="disableDate">
            <option value="">--- Sélectionnez un type pour cet événement ---</option>
            <option v-for="item in types" :value="item.id" :key="item.id">{{ item.name }}</option>
          </select>
          <div v-show="errors.has('Types')" class="alert alert-danger mt-3">{{ errors.first('Types') }}</div>
          <!-- <div class="alert alert-danger mt-3" v-show="error_form.type">
            Vous devez choisir un type pour cet événement
          </div> -->
        </div>
        <div class="form-group" v-show="typeId != '' && schoolId != ''">
          <div class="row">
            <div class="col-sm-11">
              <label for="Labels">Label <small class="text-muted">(Créez un nouveau label en cliquant sur le bouton +)</small></label>
              <select class="form-control" id="Labels" name="Labels" v-model="labelId" data-vv-as="Label" v-validate="'required'">
                <option value="">--- Sélectionnez un label pour cet événement ou créez un nouveau label en cliquant sur le bouton + ---</option>
                <option v-for="item in labels" :value="item.id" :key="item.id">{{ item.name }}</option>
              </select>
              <div v-show="errors.has('Labels')" class="alert alert-danger mt-3">{{ errors.first('Labels') }}</div>
            </div>
            <div class="col-sm-1 mt-35" v-show="schoolId != '5b9bcb5590c8a831489aefd4'">
              <span id="addIcon" class="addLabel" @click.stop="addLabel($event.target)"><font-awesome-icon icon="plus-circle" size="2x" class="add" /></span>
              <!-- <span id="deleteIcon" class="addLabel" v-show="labelId != ''" @click.stop="deleteLabel($event.target)"><font-awesome-icon icon="trash" size="2x" class="delete" /></span> -->
            </div>
            <!-- <div class="col-sm-1 mt-0" @click.stop="addLabel($event.target)">
              <span id="deleteIcon" class="addLabel"><font-awesome-icon icon="trash" size="2x" transform="down-18" class="delete" /></span>
            </div> -->
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-6">
              <label for="date_debut" class="required">Date de début</label>
              <datepicker :disabled="disableDate" id="date_debut" name="date_debut" v-model="start_date" input-class="form-control" format="dd/MM/yyyy" placeholder="Date de début de l'événement" :language="fr" :monday-first="true" :clear-button="true" :highlighted="highlightedDate" data-vv-as="Date de début" v-validate="'required'"></datepicker>
              <div v-show="errors.has('date_debut')" class="alert alert-danger mt-3">{{ errors.first('date_debut') }}</div>
              <!-- <div class="alert alert-danger mt-3" v-show="error_form.start_date">
                Vous devez choisir une date de début
              </div> -->
            </div>
            <div class="col-sm-6">
              <label for="date_fin">Date de fin</label>
              <datepicker :disabled="disableDate || start_date == ''" id="date_fin" v-model="end_date" input-class="form-control" format="dd/MM/yyyy" placeholder="Date de fin de l'événement" :language="fr" :monday-first="true" :clear-button="true" :highlighted="highlightedDate" :disabled-dates="disabledDates"></datepicker>
              <!-- <div class="alert alert-danger mt-3" v-show="error_form.end_date">
                La date de fin doit être supérieure à la date de début
              </div> -->
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-6">
              <label for="heure_debut">Horaire de début</label>
              <!-- <input type="text" class="form-control" id="heure_debut" name="heure_debut" placeholder="Horaire de début de l'événement" v-model="start_time" data-vv-as="Horaire de début" v-validate="regexTime"> -->
              <b-form-select id="heure_debut" name="heure_debut" v-model="start_time" :disabled="disableDate" :options="hours" @change="changeHours"></b-form-select>
              <!-- <div v-show="errors.has('heure_debut')" class="alert alert-danger mt-3">{{ errors.first('heure_debut') }}</div> -->
              <!-- <div class="alert alert-danger mt-3" v-show="error_form.start_time">
                Vous devez choisir un horaire de début
              </div>
              <div class="alert alert-danger mt-3" v-show="error_form.start_time_format">
                Le format de l'horaire est incorrect (ex: 09h10)
              </div> -->
            </div>
            <div class="col-sm-6">
              <label for="heure_fin">Horaire de fin</label>
              <b-form-select id="heure_fin" name="heure_fin" v-model="end_time" :options="hours_end" :disabled="!start_time || disableDate"></b-form-select>
              <!-- <input type="text" class="form-control" id="heure_fin" name="heure_fin" placeholder="Horaire de fin de l'événement" v-model="end_time" data-vv-as="Horaire de fin" v-validate="regexTime">
              <div v-show="errors.has('heure_fin')" class="alert alert-danger mt-3">{{ errors.first('heure_fin') }}</div> -->
              <!-- <div class="alert alert-danger mt-3" v-show="error_form.end_time_format">
                Le format de l'horaire est incorrect (ex: 09h10)
              </div> -->
            </div>
          </div>
        </div>
        <h4 v-if="establishments_filter.length > 0 || this.id">Adresse de l'événement</h4>
        <b-form-group class="mt-3" v-if="establishments_filter.length > 0 || this.id">
          <!-- <b-form-checkbox-group id="highlighted" v-model="highlighted" :options="optionsHighlighted" name="highlighted"></b-form-checkbox-group> -->
          <b-row v-show="typeId != '5e96e2e3c6b12aa35faa2e6b'">
            <b-col cols="12">
              <b-form-checkbox id="isLive" v-model="is_live" name="isLive">Cet événement a-t-il lieu en ligne ?</b-form-checkbox>
            </b-col>
          </b-row>
        </b-form-group>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Support du Live Event (ex : Microsoft Teams)" label-for="supportLive" v-if="(establishments_filter.length > 0 || this.id) && is_live">
                <b-form-input id="supportLive" name="supportLive" placeholder="Support du Live Event (ex : Microsoft Teams)" v-model="support_live" maxlength="20" v-validate="{ required: registration_required && is_live }" data-vv-as="Support du Live Event">
              </b-form-input>
              <div v-show="errors.has('supportLive')" class="alert alert-danger mt-3">{{ errors.first('supportLive') }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Lien pour accéder au live (sera transmis sur Salesforce)" label-for="urlLive" v-if="(establishments_filter.length > 0 || this.id) && is_live">
                <b-form-input id="urlLive" name="urlLive" placeholder="Lien pour accéder au live (sera transmis sur Salesforce)" v-model="url_live" v-validate="{ required: registration_required && is_live }" data-vv-as="Lien pour accéder au live">
              </b-form-input>
              <div v-show="errors.has('urlLive')" class="alert alert-danger mt-3">{{ errors.first('urlLive') }}</div>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="form-group" v-if="(establishments_filter.length > 0 || this.id) && !is_live">
          <div class="row">
            <div class="col-sm-3">
              <label for="address_event">Adresse<!--<span id="city"><font-awesome-icon icon="question-circle" /></span>--></label>
              <input type="text" class="form-control" id="address_event" placeholder="Adresse" v-model="address">
            </div>
            <div class="col-sm-2">
              <label for="postal_code_event">Code postal</label>
              <input type="text" class="form-control" id="postal_code_event" placeholder="Code postal" v-model="postal_code">
            </div>
            <div class="col-sm-2">
              <label for="city_event">Ville</label>
              <input type="text" class="form-control" id="city_event" placeholder="Ville" v-model="city">
            </div>
            <div class="col-sm-2">
              <label for="google_map">Google Map <a class="btn btn-sm btn-secondary" :href="googleMapUrl" target="_blank" v-show="address != '' && city != ''">Voir sur Google Maps</a></label>
              <input type="text" class="form-control" id="google_map" placeholder="Lien Google Map" v-model="google_map">
            </div>
            <div class="col-sm-3">
              <label for="contact">Contact e-mail</label>
              <input type="email" class="form-control" name="contact" id="contact" placeholder="Contact e-mail" v-model="contact" v-validate="'email'" data-vv-as="Contact e-mail">
              <div v-show="errors.has('contact')" class="alert alert-danger mt-3">{{ errors.first('contact') }}</div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12">
              <label for="description">Description (40 caractères minimum, 500 caractères maximum)</label>
              <textarea class="form-control" name="description" id="description" rows="5" v-model="description" v-validate="'min:40|max:500'" data-vv-as="description"></textarea>
              <div v-show="errors.has('description')" class="alert alert-danger mt-3">{{ errors.first('description') }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="form-group">
          <div class="row">
            <div class="col-sm-6">
              <label for="description">Description</label>
              <textarea class="form-control" id="description" rows="5" v-model="descriptionMarkdown"></textarea>
            </div>
            <div class="col-sm-6">
              <label>Rendu HTML de la description</label>
              <vue-markdown :source="descriptionMarkdown" :postrender="renderMarkdown" class="jumbotron"></vue-markdown>
            </div>
          </div>
        </div> -->
        <div class="form-group" v-show="typeId != ''">
          <div class="row">
            <div class="col-sm-4">
              <label for="link_libelle">Libellé du bouton</label>
              <select class="form-control" name="link_libelle" id="link_libelle" v-model="link_name" v-validate="{ required: linkId != '' || registration_required }" data-vv-as="Libellé du lien">
                <option value="">--- Sélectionnez un libellé pour le lien ---</option>
                <option v-for="item in link_names" :value="item" :key="item">{{ item }}</option>
              </select>
              <div v-show="errors.has('link_libelle')" class="alert alert-danger mt-3">{{ errors.first('link_libelle') }}</div>
            </div>
            <div class="col-sm-4">
              <label for="Links">Lien du bouton</label>
              <select class="form-control" name="Links" id="Links" v-model="linkId" v-validate="{ required: registration_required }" data-vv-as="Lien">
                <option value="">--- Sélectionnez un lien ou créez un lien en cliquant sur le bouton + ---</option>
                <option v-for="item in links" :value="item.id" :key="item.id">{{ item.name }}</option>
              </select>
              <div v-show="errors.has('Links')" class="alert alert-danger mt-3">{{ errors.first('Links') }}</div>
            </div>
            <div class="col-sm-1 mt-35" @click.stop="addLink($event.target)">
              <span id="addLink" class="addLink"><font-awesome-icon icon="plus-circle" size="2x" class="add" /></span>
            </div>
            <div class="col-sm-3 mt-5">
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" value="" id="registration_required" v-model="registration_required">
                  <label class="custom-control-label" for="registration_required">
                    Inscription obligatoire
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group" v-show="schoolId != '' && typeId != '' && showImages">
          <div class="row">
            <div class="col-sm-12">
              <label>Image</label><br />
              <img :src="imageName" height="50" /> <button class="btn btn-sm btn-secondary" @click.prevent="addImage($event.target)">Choisir une image</button>
            </div>
          </div>
        </div>
        <h4>Mise en avant</h4>
        <b-form-group>
          <!-- <b-form-checkbox-group id="highlighted" v-model="highlighted" :options="optionsHighlighted" name="highlighted"></b-form-checkbox-group> -->
          <b-row>
            <b-col cols="12">
              <b-form-checkbox id="highlighted" v-model="highlighted" name="highlighted">De la liste<br /><small> L’événement sera mis en surbrillance dans la liste des événements.</small></b-form-checkbox>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox id="slider" v-model="slider" name="slider">Dans le carousel en c&oelig;ur de page<br /><small>L'événement sera ajouté au carousel (événements).</small></b-form-checkbox>
            </b-col>
          </b-row>
        </b-form-group>
        <div class="form-group" v-show="isAdvance">
          <h4>Concours Advance</h4>
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" value="" id="advance" v-model="advance">
            <label class="custom-control-label" for="advance">
              Afficher cet événement sur l'agenda du Concours Advance
            </label>
          </div>
        </div>
        <div class="form-group" v-show="isAdvanceParallele">
          <h4>Advance Parallèle</h4>
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" value="" id="advancePara" v-model="advancePara">
            <label class="custom-control-label" for="advancePara">
              Afficher cet événement sur l'agenda de Advance Parallèle
            </label>
          </div>
        </div>
        <div class="form-group" v-show="isCPGE">
          <h4>Concours CPGE</h4>
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" value="" id="cpge" v-model="cpge">
            <label class="custom-control-label" for="cpge">
              Afficher cet événement sur l'agenda du Concours CPGE
            </label>
          </div>
        </div>
        <div class="form-group" v-show="isBachelor">
          <h4>Advance Bachelors</h4>
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" value="" id="bachelor" v-model="bachelor">
            <label class="custom-control-label" for="bachelor">
              Afficher cet événement sur l'agenda de Advance Bachelors
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" value="" id="active" v-model="active">
            <label class="custom-control-label" for="active">
              Evenement actif
            </label>
            <b-form-text>(décochez la case pour rendre l'événement visible à partir d'une date spécifique)</b-form-text>
          </div>
        </div>
        <div class="form-group" v-show="!active">
          <div class="row">
            <div class="col-sm-6">
              <label for="date_planned">Date de mise en ligne</label>
              <datepicker id="date_planned" name="date_planned" v-model="date_planned" input-class="form-control" format="dd/MM/yyyy" placeholder="Date prévue pour mise en ligne" :language="fr" :monday-first="true" :clear-button="true" :highlighted="highlightedDate" data-vv-as="Date de mise en ligne"></datepicker>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="role === 'admin' || schoolId === '5b9bcb7090c8a831489aefd7' || schoolId === '5b9bcb4690c8a831489aefd1' || schoolId === '5b9bcb5590c8a831489aefd4' || schoolId === '5d96008feaa7db53c25b8dd3'">
          <div class="row">
            <div class="col-sm-6">
              <label for="salesforce_campaign">ID campagne Salesforce</label>
              <input type="text" class="form-control" id="salesforce_campaign" v-model="salesforce_campaign">
            </div>
          </div>
        </div>
        <b-alert variant="info" :show="onSalesforce">
          La validation de cet événement va {{ id ? 'modifier' : 'créer' }} une campagne correspondante dans SalesForce. S’il y a un formulaire d’inscription sur votre site, les dates n’y seront proposées qu’après un délai de mise à jour du CRM.
        </b-alert>
        <button type="submit" class="btn btn-primary submit">{{ button }}</button>
        <router-link to="/events">
          <a class="btn btn-large btn-link">Revenir à la page précédente</a>
        </router-link>
      </form>
    </b-container>
    <b-modal id="modalLabel" title="Ajouter un nouveau label" @ok="handleLabelOk()" ok-variant="primary" :ok-disabled="labelExist || label == ''" ok-title="Ajouter" cancel-title="Annuler">
      <b-alert variant="danger" :show="labelExist">Le label &laquo;{{ label }}&raquo; existe déjà</b-alert>
      <input type="text" class="form-control" id="label" placeholder="Nom du label" v-model="label">
    </b-modal>
    <b-modal id="modalLabelDelete" title="Suppression d'un label" @ok="handleLabelDeleteOk()" ok-variant="danger" ok-title="Supprimer" cancel-title="Annuler">
      <p>En supprimant ce label, celui-ci ne sera plus affiché sur les événements précédents.</p>
    </b-modal>
    <b-modal id="modalLink" title="Ajouter un nouveau lien" @ok="handleLinkOk()" ok-variant="primary" :ok-disabled="linkExist || link == ''" ok-title="Ajouter" cancel-title="Annuler">
      <b-alert variant="danger" :show="linkExist">Le lien &laquo;{{ link }}&raquo; existe déjà</b-alert>
      <input type="text" class="form-control" id="link" placeholder="URL" v-model="link">
    </b-modal>
    <b-modal id="modalImage" title="Ajouter une image à cet événement" @ok="handleImageOk()" @cancel="handleImageCancel()" :ok-disabled="imageSelected == ''" ok-variant="primary" ok-title="Ajouter l'image à cet événement" cancel-title="Annuler">
      <div class="row">
        <div class="col-sm-4" v-for="item in images" :key="item.name">
          <img :src="item.name" height="100" @click.prevent="selectImage(item.id, item.name)" class="image img-fluid mb-4" :class="item.id == imageSelected ? 'selected' : ''" />
        </div>
        <div class="col-sm-4 vcenter">
          <!-- <router-link :to="'/image/edit?schoolId=' + this.schoolId + '&typeId=' + this.typeId"  target="_blank">
            <span class="btn btn-primary btn-sm" @click="addButtonImage">Ajouter une<br />nouvelle image</span>
          </router-link> -->
          <!-- <b-btn variant="outline-success" v-b-modal.modal-upload-image>Ajouter une <br />nouvelle image</b-btn> -->
        </div>
        <!-- <div class="col-sm-12" v-show="images.length == 0">
          <p>Il y a aucune image, cliquez
            <router-link :to="'/image/edit?schoolId=' + this.schoolId + '&typeId=' + this.typeId"  target="_blank">
              <a @click="addButtonImage">ici</a>
            </router-link>
            pour en ajouter une nouvelle.
          </p>
          <div class="alert alert-info">
            <p>Avant d'ajouter une image, assurez-vous que le site ajoute une image pour illustrer les événements.</p>
          </div>
        </div>
        <div class="col-sm-12">
          <button class="btn btn-primary" @click.prevent="refreshImages" v-show="showButtonImage">Raffraichir pour voir l'image</button>
        </div> -->
      </div>
      <div class="row">
        <b-col cols="12" class="text-center">
          <b-btn variant="outline-success" @click.prevent="toggleShow">Ajouter une nouvelle image</b-btn>
          <image-crop-upload
            @crop-success="uploadImage"
            v-model="showUpload"
            :width="imageWidth"
            :height="imageHeight"
            img-format="jpg"
            lang-type="fr"
            :no-circle="true"
            :no-rotate="false"
          ></image-crop-upload>
        </b-col>
      </div>
    </b-modal>
    <b-modal id="modal-upload-image" title="Uploader une image" cancel-title="Annuler" :ok-disabled="disableModalOk" ok-title="Uploader l'image" @ok="uploadImage">
      <b-alert variant="info" show>Les dimensions de l'image doivent être de imageWidth pixels en largeur et imageHeight pixels en hauteur.</b-alert>
      <b-row>
        <b-col cols="12">
          <image-uploader
            :debug="1"
            :maxWidth="imageWidth"
            :maxHeight="imageHeight"
            :autoRotate=true
            outputFormat="verbose"
            :preview=true
            capture="environment"
            accept="video/*,image/*"
            doNotResize="['gif', 'svg']"
            @input="setImage"
          ></image-uploader>
        </b-col>
      </b-row>
      <b-alert class="mt-3" variant="danger" :show="imageSizeIncorrect">Les dimensions de l'image sont incorrectes, elles doivent être de imageWidth pixels en largeur et imageHeight pixels en hauteur.</b-alert>
    </b-modal>
    <b-modal id="modalConfirmation" size="xl" @ok="handleCreateEvent()" cancel-title="Modifier l'événement" ok-title="Confirmer">
      <b-alert variant="warning" :show="eventAlreadyExist">
        Il existe déjà un événement similaire à cette date pour : {{ recapitulatif.establishments_already_exist.join(', ') }}. Merci de vérifier votre agenda.
      </b-alert>
      <p><strong>Etablissement(s) : </strong> {{ recapitulatif.establishments.join(', ') }}</p>
      <p><strong>Type :</strong> {{ recapitulatif.type }}</p>
      <p><strong>Label :</strong> {{ recapitulatif.label }}</p>
      <p><strong>Date de début :</strong> {{ recapitulatif.date_debut }}</p>
      <p v-show="recapitulatif.date_fin != ''"><strong>Date de fin :</strong> {{ recapitulatif.date_fin }}</p>
      <p v-show="recapitulatif.heure_debut != ''"><strong>Horaire de début :</strong> {{ recapitulatif.heure_debut }}</p>
      <p v-show="recapitulatif.heure_fin != ''"><strong>Horaire de fin :</strong> {{ recapitulatif.heure_fin }}</p>
      <p><strong>Evénement en live :</strong> {{ recapitulatif.is_live ? 'Oui' : 'Non' }}</p>
      <p v-show="!recapitulatif.is_live"><strong>Adresse de l'événement :</strong> {{ recapitulatif.adresse }} {{ recapitulatif.code_postal }} {{ recapitulatif.ville }}</p>
      <p v-show="!recapitulatif.is_live"><strong>Google Map :</strong> {{ recapitulatif.google_map }}</p>
      <p v-show="recapitulatif.is_live"><strong>Support live Event :</strong> {{ recapitulatif.support_live }}</p>
      <p v-show="recapitulatif.is_live"><strong>Lien du live :</strong> {{ recapitulatif.url_live }}</p>
      <p><strong>Contact :</strong> {{ recapitulatif.contact }}</p>
      <p v-show="recapitulatif.description != ''"><strong>Description :</strong> {{ recapitulatif.description }}</p>
      <p v-show="recapitulatif.lien"><strong>Lien :</strong> {{ recapitulatif.lien }}</p>
      <p v-show="recapitulatif.libelle_lien"><strong>Libellé du lien :</strong> {{ recapitulatif.libelle_lien }}</p>
      <p><strong>Inscription obligatoire</strong> : {{ recapitulatif.registration_required ? 'Oui' : 'Non' }}</p>
      <p v-show="recapitulatif.image != ''"><strong>Image :</strong> <img :src="recapitulatif.image" width="imageWidth" height="imageHeight" /></p>
      <p v-show="recapitulatif.lien_facebook != ''"><strong>Lien Facebook :</strong> {{ recapitulatif.lien_facebook }}</p>
      <p v-show="recapitulatif.lien_eventbrite != ''"><strong>Lien Eventbrite :</strong> {{ recapitulatif.lien_eventbrite }}</p>
      <p><strong>Evénement actif :</strong> {{ recapitulatif.active ? 'Oui' : 'Non' }}</p>
      <p v-show="recapitulatif.date_prevue != ''"><strong>Date de mise en ligne :</strong> {{ recapitulatif.date_prevue }}</p>
    </b-modal>
    <b-tooltip target="addIcon" title="Ajouter un nouveau label"></b-tooltip>
    <b-tooltip target="deleteIcon" title="Supprimer ce label"></b-tooltip>
    <b-tooltip target="addLink" title="Ajouter un nouveau lien"></b-tooltip>
    <b-tooltip target="city" title="Laissez vide si l'événement a lieu dans la même ville que le campus"></b-tooltip>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import Datepicker from 'vuejs-datepicker'
import { fr } from 'vuejs-datepicker/dist/locale'
import * as Ladda from 'ladda'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusCircle, faQuestionCircle, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMarkdown from 'vue-markdown'
import VeeValidate, { Validator } from 'vee-validate'
import veefr from 'vee-validate/dist/locale/fr'
import ImageUploader from 'vue-image-upload-resize'
import ImageCropUpload from 'vue-image-crop-upload'
import Salesforce from '../../class/Salesforce'
// import * as Sentry from '@sentry/browser'

library.add(faPlusCircle, faQuestionCircle, faTrash)

Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(ImageUploader)
Validator.localize('fr', veefr)
Vue.component('datepicker', Datepicker)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-markdown', VueMarkdown)

export default {
  components: {
    'image-crop-upload': ImageCropUpload
  },
  data () {
    return {
      active: true,
      advance: false,
      advancePara: false,
      address: '',
      bachelor: false,
      button: '',
      city: '',
      confirmation: '',
      confirmationMessage: '',
      contact: '',
      cpge: false,
      date_created: '',
      date_planned: '',
      description: '',
      descriptionMarkdown: '',
      disableDate: false,
      disableModalOk: true,
      end_date: '',
      end_date_registration: '',
      end_time: '',
      establishmentId: '',
      error_form: { 'title': false, 'school': false, 'end_time_format': false, 'establishment': false, 'type': false, 'start_date': false, 'start_time': false, 'start_time_format': false, 'description': false },
      establishments_already_exist: [],
      establishments_filter: [],
      establishments_selected: [],
      eventAlreadyExist: false,
      eventbrite: '',
      facebook: '',
      fr: fr,
      google_map: '',
      h1: '',
      highlighted: false,
      highlightedDate: {
        dates: [
          new Date()
        ]
      },
      hours: [{ text: '--- Sélectionnez un horaire', value: '' }, { text: '8h', disabled: false }, { text: '8h30', disabled: false }, { text: '9h', disabled: false }, { text: '9h15', disabled: false }, { text: '9h30', disabled: false }, { text: '9h45', disabled: false }, { text: '10h', disabled: false }, { text: '10h30', disabled: false }, { text: '10h45', disabled: false }, { text: '11h', disabled: false }, { text: '11h30', disabled: false }, { text: '11h45', disabled: false }, { text: '12h', disabled: false }, { text: '12h30', disabled: false }, { text: '12h45', disabled: false }, { text: '13h', disabled: false }, { text: '13h30', disabled: false }, { text: '13h45', disabled: false }, { text: '14h', disabled: false }, { text: '14h30', disabled: false }, { text: '14h45', disabled: false }, { text: '15h', disabled: false }, { text: '15h30', disabled: false }, { text: '15h45', disabled: false }, { text: '16h', disabled: false }, { text: '16h15', disabled: false }, { text: '16h30', disabled: false }, { text: '16h45', disabled: false }, { text: '17h', disabled: false }, { text: '17h30', disabled: false }, { text: '17h45', disabled: false }, { text: '18h', disabled: false }, { text: '18h30', disabled: false }, { text: '18h45', disabled: false }, { text: '19h', disabled: false }, { text: '19h30', disabled: false }, { text: '19h45', disabled: false }, { text: '20h', disabled: false }, { text: '20h30', disabled: false }, { text: '20h45', disabled: false }, { text: '21h', disabled: false }, { text: '21h45', disabled: false }, { text: '22h', disabled: false }],
      hours_end: [{ text: '--- Sélectionnez un horaire', value: '' }, { text: '8h', disabled: false }, { text: '8h30', disabled: false }, { text: '9h', disabled: false }, { text: '9h15', disabled: false }, { text: '9h30', disabled: false }, { text: '9h45', disabled: false }, { text: '10h', disabled: false }, { text: '10h30', disabled: false }, { text: '10h45', disabled: false }, { text: '11h', disabled: false }, { text: '11h30', disabled: false }, { text: '11h45', disabled: false }, { text: '12h', disabled: false }, { text: '12h30', disabled: false }, { text: '12h45', disabled: false }, { text: '13h', disabled: false }, { text: '13h30', disabled: false }, { text: '13h45', disabled: false }, { text: '14h', disabled: false }, { text: '14h30', disabled: false }, { text: '14h45', disabled: false }, { text: '15h', disabled: false }, { text: '15h30', disabled: false }, { text: '15h45', disabled: false }, { text: '16h', disabled: false }, { text: '16h15', disabled: false }, { text: '16h30', disabled: false }, { text: '16h45', disabled: false }, { text: '17h', disabled: false }, { text: '17h30', disabled: false }, { text: '17h45', disabled: false }, { text: '18h', disabled: false }, { text: '18h30', disabled: false }, { text: '18h45', disabled: false }, { text: '19h', disabled: false }, { text: '19h30', disabled: false }, { text: '19h45', disabled: false }, { text: '20h', disabled: false }, { text: '20h30', disabled: false }, { text: '20h45', disabled: false }, { text: '21h', disabled: false }, { text: '21h45', disabled: false }, { text: '22h', disabled: false }],
      image: {},
      imageId: '',
      imageName: '',
      imageNameSelected: '',
      imageSelected: '',
      imageSizeIncorrect: false,
      images: [],
      ionisId: '',
      is_live: false,
      label: '',
      labelExist: false,
      labelId: '',
      labels: [],
      link: '',
      linkExist: false,
      linkId: '',
      links: [],
      link_name: '',
      link_names: ['En savoir +', 'S\'inscrire', 'Je m\'inscris', 'Lire la suite', 'Participez', 'Read more'],
      // map: '',
      // optionsHighlighted: [{value: 1, text: 'Mise en avant slider'}, {value: 2, text: 'Mise en avant unique'}],
      patternHoraire: '^(2[0-3]|1[0-9]|0[0-9]|[^0-9][0-9])h([0-5][0-9]|[0-9])?$',
      patternUrl: '(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9].[^s]{2,})',
      regexTime: {
        // regex: '^(2[0-3]|1[0-9]|0[0-9]|[^0-9][0-9])h([0-5][0-9]|[0-9])?$'
        regex: '^([0-9]|0[0-9]|1[0-9]|2[0-3])h([0-5][0-9]|[0-9])?$'
      },
      postal_code: '',
      recapitulatif: {
        actif: '',
        adresse: '',
        code_postal: '',
        contact: '',
        date_debut: '',
        date_fin: '',
        date_prevue: '',
        description: '',
        establishments: [],
        establishments_already_exist: [],
        google_map: '',
        heure_debut: '',
        heure_fin: '',
        image: '',
        is_live: '',
        label: '',
        libelle_lien: '',
        lien: '',
        lien_eventbrite: '',
        lien_facebook: '',
        support_live: '',
        type: '',
        url_live: '',
        ville: ''
      },
      registration_required: false,
      // registration_page_expected: false,
      // registration_page_url: '',
      salesforce_campaign: '',
      // specific_page_expected: false,
      // specific_page_url: '',
      start_date: '',
      start_date_registration: '',
      start_time: '',
      schoolId: '',
      schools_filter: [],
      showButtonImage: false,
      showImages: false,
      showUpload: false,
      slider: false,
      support_live: '',
      title: '',
      total_events: 0,
      total_update: 0,
      typeId: '',
      types: [],
      url_live: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'divisionSF', 'establishments', 'recordTypeId', 'role', 'schools', 'schoolSF', 'typeSF', 'userId']),
    disabledDates () {
      let date = ''
      if (!this.id) {
        let d = new Date()
        if (this.start_date !== '') {
          date = new Date(d.setDate(this.start_date.getDate()))
        }
      }
      return {
        to: date
        // from: this.start_date
      }
    },
    googleMapUrl () {
      if (this.address === '' || this.postal_code === '' || this.city === '') {
        return ''
      }
      return 'https://www.google.fr/maps?q=' + this.address + '+' + this.postal_code + '+' + this.city
    },
    id () {
      return this.$route.params.id
    },
    imageHeight () {
      return (this.schoolId === '5b9bcb6990c8a831489aefd6' || this.schoolId === '5c93983869cf3289a90efc23') ? 480 : 186
    },
    imageWidth () {
      return (this.schoolId === '5b9bcb6990c8a831489aefd6' || this.schoolId === '5c93983869cf3289a90efc23') ? 750 : 333
    },
    isAdvance () {
      return this.schoolId === '5b9bcb3990c8a831489aefd0' || this.schoolId === '5b9bcb4690c8a831489aefd1' || this.schoolId === '5b9bcb4a90c8a831489aefd2' || this.schoolId === '5b9bcb4f90c8a831489aefd3' || this.schoolId === '5fbe3dbb27a9993f4ae91fcc'
    },
    isAdvanceParallele () {
      return this.schoolId === '5b9bcb3990c8a831489aefd0' || this.schoolId === '5b9bcb4690c8a831489aefd1' || this.schoolId === '5b9bcb4a90c8a831489aefd2' || this.schoolId === '5b9bcb4f90c8a831489aefd3' || this.schoolId === '5fdc7df66395253bd1159247'
    },
    isBachelor () {
      return this.schoolId === '5b9bcb3990c8a831489aefd0' || this.schoolId === '5b9bcb4690c8a831489aefd1' || this.schoolId === '5b9bcb4a90c8a831489aefd2' || this.schoolId === '5b9bcb4f90c8a831489aefd3' || this.schoolId === '61c060623ce2d2329d08a07a'
    },
    isCPGE () {
      return this.schoolId === '5b9bcb3990c8a831489aefd0' || this.schoolId === '5b9bcb4690c8a831489aefd1' || this.schoolId === '5b9bcb4a90c8a831489aefd2' || this.schoolId === '5fb695a9223ef498ec53920a'
    },
    isISG () {
      return this.schoolId === '63e11f451ea7572069151a14' || this.schoolId === '63e120881ea7572069151a50' || this.schoolId === '63e1218c1ea7572069151a7b' || this.schoolId === '63e1225e1ea7572069151aa5' || this.schoolId === '63e123211ea7572069151ad0' || this.schoolId === '63e0dee71ea75720691518ec' || this.schoolId === '63e1257d1ea7572069151aee' || this.schoolId === '63e125f21ea7572069151af1' || this.schoolId === '5b9bcab590c8a831489aefc9'
    },
    // hasOneSchool () {
    //   return this.schools_filter.length === 1
    // },
    onSalesforce () {
      return this.schoolSF !== '' && this.typeSF !== ''
    },
    start_date_format () {
      return this.format_date_fr(this.start_date)
    }
  },
  methods: {
    ...Vuex.mapActions(['addDivisionSF', 'addRecordTypeId', 'addSchoolSF', 'addTypeSF']),
    addButtonImage () {
      this.showButtonImage = true
    },
    addImage (button) {
      console.log('recup images', this.schoolId)
      this.images = []
      if (this.establishments_selected.length > 1) {
        this.$http.get(this.domain + '/api/images?filter[where][schoolId]=' + this.schoolId + '&filter[where][typeId]=' + this.typeId + '&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            this.images = data
          })
        }, (response) => {

        })
      } else if (this.establishments_selected.length === 1) {
        this.$http.get(this.domain + '/api/images?filter[where][establishmentId]=' + this.establishments_selected[0] + '&filter[where][typeId]=' + this.typeId + '&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            this.images = data
          })
        }, (response) => {

        })
      } else {
        this.$http.get(this.domain + '/api/images?filter[where][schoolId]=' + this.schoolId + '&filter[where][typeId]=' + this.typeId + '&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            this.images = data
          })
        }, (response) => {

        })
      }
      this.$root.$emit('bv::show::modal', 'modalImage', button)
    },
    addLabel (button) {
      this.$root.$emit('bv::show::modal', 'modalLabel', button)
    },
    addLink (button) {
      this.$root.$emit('bv::show::modal', 'modalLink', button)
    },
    addToSF (idEvent, establishment, status) {
      // Quelques types sont ajoutés dans les campagnes SF
      if (this.typeSF !== '') {
        this.$http.get(this.domain + '/api/establishments/' + establishment + '?access_token=' + this.access_token + '&filter[include]=school&filter[include]=city', { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            let school = data.school.name
            let division = data.school.name
            let city = this.isISG
              ? data.school.name.replace('ISG ', '')
              : data.city.name === 'Campus à distance'
                ? 'Distanciel'
                : data.city.name

            if (this.onSalesforce) {
              this.button = 'Création de la campagne sur Salesforce'
              // On doit créer des nouvelles variables (à cause du this)
              let type = this.typeSF
              let startDate = this.start_date
              let titleDate = this.format_date_fr(this.start_date)
              let endDate = ''
              if (this.end_date !== '' && this.end_date !== undefined) {
                endDate = this.end_date
              } else {
                endDate = this.start_date
              }
              school = this.schoolSF
              division = this.divisionSF
              let description = this.description
              let startTime = this.start_time
              let endTime = this.end_time
              let salesforceCampaign = this.salesforce_campaign
              let active = this.active
              let online = this.is_live
              let webinarUrl = this.url_live
              let findLabel = this.labels.find(l => l.id === this.labelId)
              let label = findLabel.name
              let name = ''
              // let name = this.isISG ? type + ' - ' + data.city.name + ' - ' + city + ' - ' + titleDate : this.typeSF !== 'Autre' ? this.typeSF : 'EVENT GENERIQUE' + ' - ' + city + ' - ' + titleDate

              if (this.isISG) {
                name = type + ' - ' + data.city.name + ' - ' + city + ' - ' + titleDate
              } else if (this.typeSF !== 'Autre') {
                name = this.typeSF + ' - ' + city + ' - ' + titleDate
              } else {
                name = 'EVENT GENERIQUE' + ' - ' + city + ' - ' + titleDate
              }

              let sObject = {
                Name: name,
                School__c: school,
                Division__c: division,
                Campus__c: city,
                StartDate: startDate,
                EndDate: endDate,
                EventStartHour__c: startTime,
                Type: 'Event',
                Detail__c: type,
                Label__c: label,
                Description: description,
                EventDBID__c: idEvent,
                IsActive: active,
                IsOnline__c: online,
                Webinar_URL__c: webinarUrl,
                RecordTypeId: this.recordTypeId
              }
              if (endTime !== '') {
                sObject.EventEndHour__c = endTime
              }

              let salesforce = new Salesforce()
              salesforce.login().then(
                (value) => {
                  console.log(value)
                  if (status === 'create') {
                    salesforce.create(sObject).then(
                      (value) => {
                        console.log('création campagne OK', value)
                        this.$http.post(this.domain + '/api/events/update?where[id]=' + idEvent + '&access_token=' + this.access_token, { salesforce_campaign: value.id }, { emulateJSON: true }).then((response) => {
                          response.json().then((data) => {
                            this.total_update++
                          })
                        }, (response) => {

                        })
                      },
                      (value) => {

                      }
                    )
                  }
                  if (status === 'update') {
                    sObject.Id = salesforceCampaign
                    salesforce.update([sObject]).then(
                      (value) => {
                        this.total_update++
                      },
                      (value) => {

                      }
                    )
                  }
                },
                (value) => {
                  console.log(value)
                }
              )
            } else {
              this.total_update++
            }
          })
        }, (response) => {

        })
      } else {
        this.total_update++
      }
    },
    addToSFEpitechDigital (idEvent, establishment, status) {
      // Quelques types sont ajoutés dans les campagnes SF
      console.log(this.typeSF)
      if (this.typeSF !== '') {
        this.$http.get(this.domain + '/api/establishments/' + establishment + '?access_token=' + this.access_token + '&filter[include]=school&filter[include]=city', { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            // let school = data.school.name
            // let division = data.school.name
            let city = data.city.name === 'Campus à distance' ? 'Distanciel' : data.city.name

            this.button = 'Création de la campagne sur Salesforce'
            // On doit créer des nouvelles variables (à cause du this)
            let type = this.typeSF
            let startDate = this.start_date
            let titleDate = this.format_date_fr(this.start_date)
            let endDate = ''
            if (this.end_date !== '' && this.end_date !== undefined) {
              endDate = this.end_date
            } else {
              endDate = this.start_date
            }
            // division = this.divisionSF
            let startTimeFormated = ''
            if (this.start_time !== '') {
              let startTimeSplit = this.start_time.split('h')
              let hoursStart = parseInt(startTimeSplit[0]) + 1
              if (startTimeSplit[1] !== '') {
                startTimeFormated = hoursStart + ':' + startTimeSplit[1]
              } else {
                startTimeFormated = hoursStart
              }
            }
            let endTimeFormated = ''
            if (this.end_time !== '') {
              let endTimeSplit = this.end_time.split('h')
              let hoursEnd = parseInt(endTimeSplit[0]) + 1
              if (endTimeSplit[1] !== '') {
                endTimeFormated = hoursEnd + ':' + endTimeSplit[1]
              } else {
                endTimeFormated = hoursEnd
              }
            }
            let description = this.description
            let startTime = startTimeFormated
            let endTime = endTimeFormated
            let salesforceCampaign = this.salesforce_campaign
            let active = this.active
            let webinarUrl = this.url_live
            let findLabel = this.labels.find(l => l.id === this.labelId)
            let label = findLabel.name
            let online = this.is_live

            type = type === 'JDMI' ? 'Journée Immersive' : type

            let sObject = {
              Name: (type === 'Atelier' && this.divisionSF === 'Epitech Digital' ? 'Digiclub' : type) + ' - ' + city + ' - ' + titleDate,
              Ecole__c: this.divisionSF,
              Campus__c: city,
              StartDate: startDate,
              EndDate: endDate,
              Type: 'Event',
              Detail__c: type,
              Label__c: label,
              Description: description,
              Event_DB_ID__c: idEvent,
              IsOnline__c: online,
              IsActive: active,
              Webinar_URL__c: webinarUrl
              // RecordTypeId: this.recordTypeId
            }
            if (startTime !== '') {
              sObject.EventStartHour__c = startTime
            }
            if (endTime !== '') {
              sObject.EventEndHour__c = endTime
            }

            // Sentry.setContext('sobject', sObject)
            // Sentry.captureMessage('objet SF Epitech D')

            let salesforce = new Salesforce()
            salesforce.login().then(
              (value) => {
                console.log(value)
                if (status === 'create') {
                  salesforce.createEda(sObject).then(
                    (value) => {
                      console.log('création campagne OK', value)
                      this.$http.post(this.domain + '/api/events/update?where[id]=' + idEvent + '&access_token=' + this.access_token, { salesforce_campaign: value.id }, { emulateJSON: true }).then((response) => {
                        response.json().then((data) => {
                          this.total_update++
                        })
                      }, (response) => {

                      })
                    },
                    (value) => {
                      // Sentry.setContext('error', value)
                      // Sentry.captureMessage('error SF Epitech D')
                    }
                  )
                }
                if (status === 'update') {
                  sObject.Id = salesforceCampaign
                  salesforce.updateEda([sObject]).then(
                    (value) => {
                      this.total_update++
                    },
                    (value) => {

                    }
                  )
                }
              },
              (value) => {
                console.log(value)
              }
            )
          })
        }, (response) => {

        })
      } else {
        this.total_update++
      }
    },
    addToSFEpitech (idEvent, establishment, status) {
      // Quelques types sont ajoutés dans les campagnes SF
      if (this.typeSF !== '') {
        this.$http.get(this.domain + '/api/establishments/' + establishment + '?access_token=' + this.access_token + '&filter[include]=school&filter[include]=city', { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            let school = data.school.name
            let city = data.city.name

            if (school === 'Epitech' || school === 'Epitech Digital') {
              this.button = 'Création de la campagne sur Salesforce'
              // On doit créer des nouvelles variables (à cause du this)
              let nameSchool = school === 'Epitech' ? 'Epitech IT' : 'Epitech Digital'
              let type = this.typeSF
              let startDate = this.start_date
              let titleDate = this.format_date_fr(this.start_date)
              let endDate = this.end_date
              school = this.schoolSF
              let description = this.description
              let salesforceCampaign = this.salesforce_campaign
              let active = this.active

              let sObject = {
                Name: type + ' ' + nameSchool + ' - ' + city + ' - ' + titleDate,
                Campus__c: city,
                StartDate: startDate,
                Detail__c: type,
                Description: description,
                EventDBID__c: idEvent,
                IsActive: active
              }
              if (endDate !== '') {
                sObject.EndDate = endDate
              }
              let salesforce = new Salesforce()
              salesforce.loginEpitech().then(
                (value) => {
                  console.log(value)
                  if (status === 'create') {
                    salesforce.create(sObject).then(
                      (value) => {
                        console.log('création campagne OK', value)
                        this.$http.post(this.domain + '/api/events/update?where[id]=' + idEvent + '&access_token=' + this.access_token, { salesforce_campaign: value.id }, { emulateJSON: true }).then((response) => {
                          response.json().then((data) => {
                            this.total_update++
                          })
                        }, (response) => {

                        })
                      },
                      (value) => {

                      }
                    )
                  }
                  if (status === 'update') {
                    sObject.Id = salesforceCampaign
                    salesforce.update(sObject).then(
                      (value) => {
                        this.total_update++
                      },
                      (value) => {

                      }
                    )
                  }
                },
                (value) => {
                  console.log(value)
                }
              )
            } else {
              this.total_update++
            }
          })
        }, (response) => {

        })
      } else {
        this.total_update++
      }
    },
    changeHours (val) {
      console.log(val)
      if (this.end_date === '') {
        let bool = true
        for (let i = 1; i < this.hours_end.length; i++) {
          this.hours_end[i].disabled = bool
          if (this.hours_end[i].text === this.start_time) {
            bool = !bool
          }
        }
      }
    },
    compare (a, b) {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()
      let comparison = 0

      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }

      return comparison
    },
    compareCity (a, b) {
      const nameA = a.city.name.toUpperCase()
      const nameB = b.city.name.toUpperCase()
      let comparison = 0

      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }

      return comparison
    },
    createLog (id, type) {
      let log = {
        date: new Date().toISOString(),
        eventId: id,
        ionisId: this.userId,
        name: type
      }
      this.$http.post(this.domain + '/api/logs?access_token=' + this.access_token, log, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {

        })
      }, (response) => {

      })
    },
    cropSuccess (image, field) {
      this.image = image
    },
    deleteLabel (button) {
      this.$root.$emit('bv::show::modal', 'modalLabelDelete', button)
    },
    edit () {
      this.$validator.validateAll().then((result) => {
        console.log(result)
        if (result) {
          // On vérifie qu'un événement existe pas déjà
          if (!this.id) {
            // this.$http.get(this.domain + '/api/events?access_token=' + this.access_token + '&filter[where][schoolId]=' + this.schoolId, { emulateJSON: true }).then((response) => {
            //   response.json().then((data) => {

            //   })
            // }, (response) => {

            // })
          }
          this.recapitulatif.active = this.active
          this.recapitulatif.adresse = this.address
          this.recapitulatif.code_postal = this.postal_code
          this.recapitulatif.date_debut = this.format_date_fr(this.start_date)
          this.recapitulatif.date_fin = this.format_date_fr(this.end_date)
          this.recapitulatif.date_prevue = this.format_date_fr(this.date_planned)
          this.recapitulatif.description = this.description
          this.recapitulatif.establishments = []
          for (let i = 0; i < this.establishments_selected.length; i++) {
            let id = this.establishments_selected[i]
            let obj = this.establishments_filter.find(a => a.id === id)
            let school = obj.school.name
            let city = obj.city.name
            this.recapitulatif.establishments.push(school + ' ' + city)
          }
          this.recapitulatif.is_live = this.is_live
          this.recapitulatif.google_map = this.google_map
          this.recapitulatif.contact = this.contact
          this.recapitulatif.heure_debut = this.start_time
          this.recapitulatif.heure_fin = this.end_time
          this.recapitulatif.image = this.imageName
          if (this.labelId !== '') {
            let label = this.labels.find(l => l.id === this.labelId)
            this.recapitulatif.label = label.name
          }
          this.recapitulatif.libelle_lien = this.link_name
          this.recapitulatif.registration_required = this.registration_required
          if (this.linkId !== '' && this.linkId !== undefined) {
            let link = this.links.find(l => l.id === this.linkId)
            this.recapitulatif.lien = link.name
          }
          this.recapitulatif.lien_eventbrite = this.eventbrite
          this.recapitulatif.lien_facebook = this.facebook
          let type = this.types.find(t => t.id === this.typeId)
          this.recapitulatif.support_live = this.support_live
          this.recapitulatif.type = type.name
          this.recapitulatif.url_live = this.url_live
          this.recapitulatif.ville = this.city
          // On vérifie si il existe pas déjà un événement similaire
          if (this.establishments_selected.length > 0) {
            let where = []
            for (let i = 0; i < this.establishments_selected.length; i++) {
              where.push({ and: [ { establishmentId: this.establishments_selected[i] }, { labelId: this.labelId }, { typeId: this.typeId }, { start_date: new Date(this.start_date).toISOString().substring(0, 10) }, { start_time: this.start_time }, { end_time: this.end_time } ] })
            }
            let filter = {
              where: {
                or: where
              },
              include: [{ establishment: ['city', 'school'] }]
            }
            filter = encodeURIComponent(JSON.stringify(filter))
            this.$http.get(this.domain + '/api/events?filter=' + filter + '&access_token=' + this.access_token).then((response) => {
              response.json().then((data) => {
                if (data.length === 0) {
                  this.eventAlreadyExist = false
                } else {
                  this.eventAlreadyExist = true
                  for (let i = 0; i < data.length; i++) {
                    this.establishments_already_exist.push(data[i].establishment.school.name + ' ' + data[i].establishment.city.name)
                  }
                  this.recapitulatif.establishments_already_exist = this.establishments_already_exist
                }
                this.$root.$emit('bv::show::modal', 'modalConfirmation')
              })
            }, (response) => {

            })
          } else {
            this.$root.$emit('bv::show::modal', 'modalConfirmation')
          }
        } else {
          this.$root.$bvToast.toast('Certains champs n\'ont pas été renseignés.', {
            title: 'Validation impossible',
            autoHideDelay: 3000,
            append: false,
            variant: 'danger'
          })
        }
      })
    },
    format_date (value) {
      let date = new Date(value)
      if (value) {
        return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      }
      return value
    },
    format_date_fr (value) {
      let date = new Date(value)
      if (value) {
        return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()
      }
      return value
    },
    getEstablishments () {
      // On reset par défaut certaines valeurs sinon on aura des surprises ^^
      this.establishments_filter = []
      this.establishments_selected = []
      this.$http.get(this.domain + '/api/establishments?access_token=' + this.access_token + '&filter[include]=school&filter[include]=city&filter[where][schoolId]=' + this.schoolId, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            if (this.establishments.includes(data[i].id)) {
              this.establishments_filter.push(data[i])
              this.establishments_filter = this.establishments_filter.sort(this.compareCity)
            }
          }
          if (this.establishments_filter.length === 1) {
            this.address = this.establishments_filter[0].address
            this.postal_code = this.establishments_filter[0].zip_code
            this.city = this.establishments_filter[0].city.name
            this.google_map = this.establishments_filter[0].map
            this.establishments_selected.push(this.establishments_filter[0].id)
          } else if (!this.id) {
            this.address = ''
            this.postal_code = ''
            this.city = ''
            this.google_map = ''
          }
        })
      }, (response) => {

      })
    },
    getImages () {
      this.$http.get(this.domain + '/api/images?access_token=' + this.access_token + '&filter[where][schoolId]=' + this.schoolId + '&filter[where][typeId]=' + this.typeId + '&filter[where][bydefault]=true', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          if (data.length > 0) {
            this.imageId = data[0].id
            this.imageSelected = data[0].id
            this.imageName = data[0].name
            this.imageNameSelected = data[0].name
          }
        })
      }, (response) => {

      })
    },
    getLabels (value, typeId) {
      if (value) {
        this.labelId = ''
      }
      // if (typeId !== '' && typeId !== undefined) {
      this.$http.get(this.domain + '/api/labels?access_token=' + this.access_token + '&filter[where][schoolId]=' + this.schoolId + '&filter[where][typeId]=' + this.typeId + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.labels = data
          if (typeId === undefined) {
            // On sélectionne le label correspondant au type
            let indexType = this.types.findIndex(type => type.id === this.typeId)
            console.log('==', indexType)
            let typeName = this.types[indexType].name
            console.log('==', typeName)
            let indexLabel = this.labels.findIndex(label => label.name === typeName)
            console.log(indexLabel)
            if (indexLabel !== -1) {
              this.labelId = this.labels[indexLabel].id
            }
          } else {
            this.labelId = typeId
          }
        })
      }, (response) => {

      })
      // }
    },
    getLinks (value) {
      if (value) {
        this.linkId = ''
      }
      this.$http.get(this.domain + '/api/links?access_token=' + this.access_token + '&filter[where][schoolId]=' + this.schoolId + '&filter[where][typeId]=' + this.typeId + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.links = data
        })
      }, (response) => {

      })
    },
    getTypes (schoolId) {
      this.types = []
      this.$http.get(this.domain + '/api/types?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            let type = data[i].schools.find(a => a.id === schoolId)
            if (type !== undefined) {
              this.types.push({
                id: data[i].id,
                name: data[i].name
              })
            }
          }
        })
      }, (response) => {

      })
    },
    handleCreateEvent () {
      let event = {
        active: this.active,
        advance: this.advance,
        advancePara: this.advancePara,
        address: this.address,
        bachelor: this.bachelor,
        city: this.city,
        contact: this.contact,
        cpge: this.cpge,
        // date_planned: new Date(this.date_planned).toISOString().substring(0, 10),
        description: this.description,
        end_time: this.end_time,
        establishmentId: this.establishmentId,
        eventbrite: this.eventbrite,
        facebook: this.facebook,
        google_map: this.google_map,
        highlighted: this.highlighted,
        // registration_page_url: this.registration_page_url,
        // specific_page_url: this.specific_page_url,
        imageId: this.imageId,
        is_live: this.is_live,
        // ionisId: this.userId,
        labelId: this.labelId,
        linkId: this.linkId,
        link_name: this.link_name,
        postal_code: this.postal_code,
        registration_required: this.registration_required,
        salesforce_campaign: this.salesforce_campaign,
        slider: this.slider,
        start_date: new Date(this.start_date).toISOString().substring(0, 10),
        start_time: this.start_time,
        support_live: this.support_live,
        title: this.title,
        typeId: this.typeId,
        url_live: this.url_live
      }

      if (this.date_planned !== '' && this.date_planned !== undefined) {
        event.date_planned = new Date(this.date_planned).toISOString().substring(0, 10)
      }
      if (this.end_date !== '' && this.end_date !== undefined) {
        event.end_date = new Date(this.end_date).toISOString().substring(0, 10)
      }
      if (this.start_date_registration !== '' && this.start_date_registration !== undefined) {
        event.start_date_registration = new Date(this.start_date_registration).toISOString().substring(0, 10)
      }
      if (this.end_date_registration !== '' && this.end_date_registration !== undefined) {
        event.end_date_registration = new Date(this.end_date_registration).toISOString().substring(0, 10)
      }
      let l = Ladda.create(document.querySelector('.submit'))
      l.start()
      if (!this.id) {
        event.date_created = new Date().toISOString()
        event.ionisId = this.userId
        this.button = 'Création de l\'événement'
        this.total_events = this.establishments_selected.length
        for (let i = 0; i < this.establishments_selected.length; i++) {
          event.establishmentId = this.establishments_selected[i]
          this.$http.post(this.domain + '/api/events?access_token=' + this.access_token, event, { emulateJSON: true }).then((response) => {
            response.json().then((data) => {
              // Ajout du log
              this.createLog(data.id, 'Creation')
              if (response.status === 200 && response.ok) {
                if (this.schoolId === '5d96008feaa7db53c25b8dd3') {
                  this.addToSFEpitechDigital(data.id, this.establishments_selected[i], 'create')
                } else {
                  this.addToSF(data.id, this.establishments_selected[i], 'create')
                }
              }
            })
          }, (response) => {

          })
        }
      } else {
        event.date_created = this.date_created
        event.date_updated = new Date().toISOString()
        event.ionisId = this.ionisId
        this.button = 'Modification de l\'événement'
        this.$http.post(this.domain + '/api/events/' + this.id + '/replace?access_token=' + this.access_token, event, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            // Ajout du log
            this.createLog(data.id, 'Mise à jour')
            if (response.status === 200 && response.ok) {
              if (this.schoolId === '5d96008feaa7db53c25b8dd3') {
                this.addToSFEpitechDigital(data.id, data.establishmentId, 'update')
              } else {
                this.addToSF(data.id, data.establishmentId, 'update')
              }
              this.$root.$bvToast.toast(this.confirmationMessage, {
                title: this.confirmation,
                autoHideDelay: 3000,
                append: false,
                variant: 'success'
              })
              this.$router.push({name: 'Events'})
            }
          })
        }, (response) => {

        })
      }
    },
    handleImageCancel () {
      this.imageSelected = this.imageId !== '' ? this.imageId : ''
      this.imageNameSelected = this.imageName !== '' ? this.imageName : ''
    },
    handleImageOk () {
      this.imageId = this.imageSelected
      this.imageName = this.imageNameSelected
    },
    handleLabelDeleteOk () {
      this.$http.delete(this.domain + '/api/labels/' + this.labelId + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          if (response.status === 200 && response.ok) {
            this.getLabels(true)
          }
        })
      }, (response) => {

      })
    },
    handleLabelOk () {
      let newLabel = {
        name: this.label,
        typeId: this.typeId,
        schoolId: this.schoolId
      }
      this.$http.get(this.domain + '/api/labels?access_token=' + this.access_token + '&filter[where][schoolId]=' + this.schoolId + '&filter[where][typeId]=' + this.typeId + '&filter[where][name]=' + this.label, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          if (data.length === 0) {
            this.$http.post(this.domain + '/api/labels?access_token=' + this.access_token, newLabel, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.getLabels(true, data.id)
                  this.labelId = data.id // useless
                }
              })
            }, (response) => {

            })
          } else {
            this.labelId = data[0].id
          }
        })
      }, (response) => {

      })
    },
    handleLinkOk () {
      let newLink = {
        name: this.link,
        typeId: this.typeId,
        schoolId: this.schoolId
      }
      this.$http.get(this.domain + '/api/links?access_token=' + this.access_token + '&filter[where][schoolId]=' + this.schoolId + '&filter[where][typeId]=' + this.typeId + '&filter[where][name]=' + this.link_name, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          if (data.length === 0) {
            this.$http.post(this.domain + '/api/links?access_token=' + this.access_token, newLink, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.getLinks(true)
                  this.linkId = data.id
                }
              })
            }, (response) => {

            })
          } else {
            this.linkId = data[0].id
          }
        })
      }, (response) => {

      })
    },
    hasImages (schoolId) {
      for (let i = 0; i < this.schools_filter.length; i++) {
        if (this.schools_filter[i].id === schoolId) {
          this.showImages = this.schools_filter[i].images
        }
      }
    },
    selectImage (id, name) {
      this.imageSelected = id
      this.imageNameSelected = name
    },
    setImage: function (file) {
      let ratio = file.info.aspectRatio
      console.log(ratio)
      if (ratio === 1.79) {
        this.image = file
        this.disableModalOk = false
        this.imageSizeIncorrect = false
        console.log('ratio ok')
      } else {
        console.log('ratio ko')
        this.image = ''
        this.imageSizeIncorrect = true
      }
    },
    refreshImages () {
      this.addImage(null)
      this.showButtonImage = false
    },
    renderMarkdown (string) {
      this.description = string
      return string
    },
    testPattern (horaire) {
      let regex = RegExp(this.patternHoraire)

      return regex.test(horaire)
    },
    testPatternUrl (url) {
      let regex = RegExp(this.patternUrl)

      return regex.test(url)
    },
    toggleShow () {
      this.showUpload = !this.showUpload
    },
    uploadImage (image, field) {
      this.image = image
      let data = {}
      if (this.establishments_selected.length === 1) {
        data = {
          establishmentId: this.establishments_selected[0],
          name: this.image,
          schoolId: this.schoolId,
          typeId: this.typeId
        }
      } else {
        data = {
          name: this.image,
          schoolId: this.schoolId,
          typeId: this.typeId
        }
      }
      console.log(data)
      this.$http.post(this.domain + '/api/images?access_token=' + this.access_token, data, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          if (response.status === 200 && response.ok) {
            this.addImage(null)
            this.imageNameSelected = this.image
            this.imageSelected = data.id
            this.disableModalOk = true
          }
        })
      }, (response) => {

      })
    }
  },
  watch: {
    date_planned (value) {
      console.log(value)
      if (value === null) {
        this.date_planned = ''
      }
    },
    end_date (value) {
      if (value === null) {
        this.end_date = ''
      }
    },
    establishments_selected (value) {
      if (value.length === 1) {
        let establishment = this.establishments_filter.find(x => x.id === value[0])
        this.address = establishment.address
        this.postal_code = establishment.zip_code
        this.city = establishment.ville
        this.google_map = establishment.map
      } else if (!this.id) {
        this.address = ''
        this.postal_code = ''
        this.city = ''
        this.google_map = ''
      }
      if (this.isISG) {
        if (value.indexOf('63e1253d1ea7572069151aec') > -1 || value.indexOf('63e125621ea7572069151aed') > -1 || value.indexOf('63e124a51ea7572069151aeb') > -1 || value.indexOf('63e124501ea7572069151aea') > -1 || value.indexOf('63e123f21ea7572069151ae8') > -1 || value.indexOf('63e124311ea7572069151ae9') > -1 || value.indexOf('63e123c01ea7572069151ae6') > -1 || value.indexOf('63e123631ea7572069151ad1') > -1) {
          this.addSchoolSF('')
        } else {
          this.addSchoolSF(this.schoolId)
        }
      }
    },
    googleMapUrl (value) {
      this.google_map = this.googleMapUrl
    },
    label (value) {
      console.log('label', value)
      let label = this.labels.find(a => a.name === value)
      console.log(label)
      if (label !== undefined) {
        this.labelExist = true
      } else {
        this.labelExist = false
      }
    },
    link (value) {
      console.log('link', value)
      let link = this.links.find(a => a.name === value)
      console.log(link)
      if (link !== undefined) {
        this.linkExist = true
      } else {
        this.linkExist = false
      }
    },
    salesforce_campaign (value) {
      if (value) {
        // On cherche si la campagne a des utilisateurs
        let items = [{
          salesforce_campaign: value
        }]
        let salesforce = new Salesforce()
        if (this.schoolId !== '5d96008feaa7db53c25b8dd3') {
          salesforce.login().then(
            (value) => {
              salesforce.getLeadCampaignMember(items).then(
                (value) => {
                  if (value.length > 0 && this.role !== 'admin') {
                    this.disableDate = true
                  }
                },
                (value) => {

                }
              )
            },
            (value) => {

            }
          )
        }

        if (this.schoolId === '5d96008feaa7db53c25b8dd3') {
          salesforce.login().then(
            (value) => {
              salesforce.getLeadCampaignMemberEda(items).then(
                (value) => {
                  if (value.length > 0) {
                    this.disableDate = true
                  }
                },
                (value) => {

                }
              )
            },
            (value) => {

            }
          )
        }
      }
    },
    schoolId (id) {
      if (id === '5b9bcb4690c8a831489aefd1') {
        this.addRecordTypeId('0121p000000BHqT')
      }
      // Ici code si une ecole bachelor existe
      if (id === '61c060623ce2d2329d08a07a') {
        this.bachelor = true
      } else {
        if (this.id === '') {
          this.bachelor = false
        }
      }
      if (id === '5fb695a9223ef498ec53920a') {
        this.cpge = true
      } else {
        if (this.id === '') {
          this.cpge = false
        }
      }
      if (id === '5fbe3dbb27a9993f4ae91fcc') {
        this.advance = true
      } else {
        if (this.id === '') {
          this.advance = false
        }
      }
      if (id === '5fdc7df66395253bd1159247') {
        this.advancePara = true
      } else {
        if (this.id === '') {
          this.advancePara = false
        }
      }
    },
    total_update (number) {
      if (number === this.total_events) {
        this.$root.$bvToast.toast(this.confirmationMessage, {
          title: this.confirmation,
          autoHideDelay: 3000,
          append: false,
          variant: 'success'
        })
        this.$router.push({name: 'Events'})
      }
    },
    typeId (value) {
      if (value !== '' && (this.imageId === '' || this.imageId === undefined || this.imageId === 'undefined')) {
        this.getImages()
      }
      if (value === '5e96e2e3c6b12aa35faa2e6b') {
        this.is_live = true
      }
      // On autorise l'ajout de campagne pour ESME seulement pour le type JDMI
      if ((value === '5bd0237d08695f9cd07a0092' || value === '5dd3ac53a413380bd3698710' || value === '5ba8a2381b1a92ca1db3f662' || value === '5b9fcacdc2e4315bd836890d' || value === '6012b7b503ec68c4e6899166' || value === '6347c35b276f97549c7d9160') && this.schoolId === '5b9bcb4690c8a831489aefd1') {
        this.addSchoolSF('ESME')
      } else if (this.schoolId === '5b9bcb4690c8a831489aefd1') {
        this.addSchoolSF('')
      }

      if (this.schoolId === '5b9bcb6990c8a831489aefd6' && (value === '5bd0237d08695f9cd07a0092' || value === '5dd3ac53a413380bd3698710' || value === '5ba8a2381b1a92ca1db3f662')) {
        this.addTypeSF('eartdecouverte')
      } else if (this.schoolId === '5b9bcb6990c8a831489aefd6') {
        this.addTypeSF(this.typeId)
      }

      // Merci ISG
      if (this.isISG) {
        if (this.establishments_selected.indexOf('63e1253d1ea7572069151aec') > -1 || this.establishments_selected.indexOf('63e125621ea7572069151aed') > -1 || this.establishments_selected.indexOf('63e124a51ea7572069151aeb') > -1 || this.establishments_selected.indexOf('63e124501ea7572069151aea') > -1 || this.establishments_selected.indexOf('63e123f21ea7572069151ae8') > -1 || this.establishments_selected.indexOf('63e124311ea7572069151ae9') > -1 || this.establishments_selected.indexOf('63e123c01ea7572069151ae6') > -1 || this.establishments_selected.indexOf('63e123631ea7572069151ad1') > -1) {
          this.addSchoolSF('')
        } else {
          this.addSchoolSF(this.schoolId)
        }
      }
    }
  },
  mounted () {
    if (this.id) {
      this.$http.get(this.domain + '/api/events/' + this.id + '?filter[include]=image&filter[include][establishment]=school&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.active = data.active
          this.advance = data.advance
          this.advancePara = data.advancePara
          this.address = data.address
          this.bachelor = data.bachelor
          this.city = data.city
          this.contact = data.contact
          this.cpge = data.cpge
          this.date_created = data.date_created
          this.date_planned = this.format_date(data.date_planned)
          this.description = data.description
          this.end_date = this.format_date(data.end_date)
          this.end_date_registration = this.format_date(data.end_date_registration)
          this.end_time = data.end_time
          this.establishmentId = data.establishmentId
          this.facebook = data.facebook
          this.eventbrite = data.eventbrite
          this.google_map = data.google_map
          this.highlighted = data.highlighted
          this.imageId = data.imageId
          this.is_live = data.is_live
          if (data.image !== undefined) {
            this.imageName = data.image.name
          }
          this.imageSelected = data.imageId
          this.ionisId = data.ionisId
          this.labelId = data.labelId
          this.linkId = data.linkId
          this.link_name = data.link_name
          // this.map = data.map
          this.postal_code = data.postal_code
          this.registration_required = data.registration_required
          // this.registration_page_url = data.registration_page_url
          this.salesforce_campaign = data.salesforce_campaign
          this.slider = data.slider
          // this.specific_page_url = data.specific_page_url
          this.start_date = this.format_date(data.start_date)
          this.start_date_registration = this.format_date(data.start_date_registration)
          this.start_time = data.start_time
          this.support_live = data.support_live
          this.title = data.title
          this.typeId = data.typeId
          this.url_live = data.url_live
          // if (this.registration_page_url !== '') {
          //   this.registration_page_expected = true
          // }
          // if (this.specific_page_url !== '') {
          //   this.specific_page_expected = true
          // }
          this.schoolId = data.establishment.school.id
          this.getEstablishments()
          // this.getLabels()
          this.hasImages(this.schoolId)
          this.getTypes(this.schoolId)
          this.getLabels(false)
          this.getLinks(false)
          this.addSchoolSF(this.schoolId)
          this.addDivisionSF(this.schoolId)
          this.addTypeSF(this.typeId)
        })
      }, (response) => {
        console.log('response', response)
        if (response.status === 404) {
          this.$root.$bvToast.toast('L\'événement n\'existe pas ou a été supprimé.', {
            title: 'Evénement inexistant ou supprimé',
            autoHideDelay: 3000,
            append: false,
            variant: 'danger'
          })
          this.$router.push({name: 'Events'})
        }
      })
      this.button = 'Editer'
      this.h1 = 'Editer un événement'
      this.confirmation = 'Evénement modifié'
      this.confirmationMessage = 'L\'événement a bien été modifié'
    } else {
      this.button = 'Valider'
      this.h1 = 'Ajouter un événement'
      this.confirmation = 'Evénement crée'
      this.confirmationMessage = 'L\'événement a bien été crée'
    }

    // Récupération des types et des écoles
    // this.$http.get(this.domain + '/api/types?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
    //   response.json().then((data) => {
    //     this.types = data
    //   })
    // }, (response) => {

    // })

    this.$http.get(this.domain + '/api/schools?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
      response.json().then((data) => {
        for (let i = 0; i < data.length; i++) {
          // if (this.schools.includes(data[i].id)) {
          //   this.schools_filter.push(data[i])
          // }
          let school = this.schools.find(a => a.id === data[i].id)
          if (school !== undefined) {
            this.schools_filter.push(data[i])
          }
        }
        this.schools_filter = this.schools_filter.sort(this.compare)
        if (this.schools_filter.length === 1) {
          this.schoolId = this.schools_filter[0].id
          this.getEstablishments()
        }
        this.hasImages(this.schoolId)
        this.getTypes(this.schoolId)
        this.getLabels(false)
        this.getLinks(false)
        this.addSchoolSF(this.schoolId)
        this.addDivisionSF(this.schoolId)
        this.addTypeSF(this.typeId)
      })
    }, (response) => {

    })

    if (this.id) {
      this.$http.get(this.domain + '/api/establishments?access_token=' + this.access_token + '&filter[include]=school&filter[include]=city&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            if (this.establishments.includes(data[i].id)) {
              this.establishments_filter.push(data[i])
              this.establishments_filter = this.establishments_filter.sort(this.compareCity)
              // this.schoolId = data[i].schoolId // On récupère le schoolId pour afficher le type et le label
            }
            if (this.establishmentId === data[i].id) {
              this.schoolId = data[i].schoolId // On récupère le schoolId pour afficher le type et le label
              this.getImages() // ????
            }
          }
        })
      }, (response) => {

      })
    }
  }
}
</script>

<style lang="scss">
  .addLabel, .addLink {
    cursor: pointer;
  }
  .image {
    border: 3px solid transparent;
    &:hover {
      cursor: pointer;
      border: 3px solid transparent;
    }
    &.selected {
      border: 3px solid #007bff;
    }
  }
  .vcenter {
    display: flex;
    align-items: center;
  }
  .jumbotron {
    padding: 2rem !important;
  }
  .mt-35 {
    margin-top: 2rem;
  }
  option:disabled {
    background-color: #dedede;
    // color: #000;
  }
  .vdp-datepicker input[disabled] + .vdp-datepicker__clear-button {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Events/Edit.vue